var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2Teleruptor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 45h20v4H7v-4zm44-11H40v-9h-4v9H25v4h26v-4zm-2 11v4h20v-4H49z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Teleruptor.9d93eb9a.svg";
export { SvgA2Teleruptor as ReactComponent };